import React, { FC } from 'react';

import PropTypes from 'prop-types';

import Button from '@adsk/alloy-react-button';
import { CheckmarkIcon, RenderIconType, XIcon } from '@adsk/alloy-react-icon';

import useInlineInput from './useInlineInput';

type EditButtonGroupProps = Pick<
  ReturnType<typeof useInlineInput>,
  'handleCancel' | 'handleSubmit' | 'modified' | 'editButtonTokens'
> & {
  error?: boolean;
};

const preventOnBlur = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
  e.preventDefault();
};

const renderXIcon: RenderIconType = (p) => <XIcon {...p} />;
const renderCheckmarkIcon: RenderIconType = (p) => <CheckmarkIcon {...p} />;

/**
 * A Button Group for the edit mode of InlineEdit
 */
const EditButtonGroup: FC<EditButtonGroupProps> = ({
  handleCancel,
  handleSubmit,
  modified,
  editButtonTokens,
  error = false,
}) => {
  const { cancel, submit } = editButtonTokens ?? {};

  return (
    <>
      <Button
        onClick={handleCancel}
        onMouseDown={preventOnBlur}
        renderIcon={renderXIcon}
        size={Button.SIZES.SMALL}
        style={cancel}
      />
      <Button
        onClick={handleSubmit}
        onMouseDown={preventOnBlur}
        renderIcon={renderCheckmarkIcon}
        size={Button.SIZES.SMALL}
        disabled={error}
        style={[submit?._, !modified && !error && submit?.inactive]}
        variant={
          modified || error
            ? Button.VARIANTS.PRIMARY
            : Button.VARIANTS.SECONDARY
        }
      />
    </>
  );
};

EditButtonGroup.displayName = 'EditButtonGroup';

EditButtonGroup.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  handleCancel: PropTypes.func.isRequired,
  modified: PropTypes.bool.isRequired,
  error: PropTypes.bool,
};
export default EditButtonGroup;
